import { IsIn, IsOptional, IsString, IsArray, MaxLength, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import { Constants } from "@eagerdog/constants";

import { IPostMedia, PostMediaType, PostType } from "./post.interface";

/** Post types a user or club may create directly; the rest are system activity. */
export const USER_CREATABLE_POST_TYPES: PostType[] = [
  Constants.post_type.club_update,
  Constants.post_type.photo,
  Constants.post_type.video,
  Constants.post_type.run_result,
];

class PostMediaDto implements IPostMedia {
  @IsIn(Object.values(Constants.post_media_type))
  type!: PostMediaType;

  @IsString()
  url!: string;

  @IsOptional()
  @IsString()
  thumbnail_url?: string;
}

export class CreatePostDto {
  @IsIn(USER_CREATABLE_POST_TYPES)
  post_type!: PostType;

  @IsOptional()
  @IsString()
  @MaxLength(2000)
  body?: string;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => PostMediaDto)
  media?: IPostMedia[];

  @IsOptional()
  @IsString()
  dog_id?: string;

  @IsOptional()
  @IsString()
  run_result_id?: string;

  @IsOptional()
  @IsString()
  linked_event_id?: string;
}
